<template>
  <div class="footmark">
    <el-table :data="tableData" ref="table">
      <el-table-column :label="$t('footmark.col1')" width="130px">
        <template slot-scope="scope">
          <el-image
            :src="imgUrlFilter(scope.row.ProductPhoto)"
            fit="cover"
            class="image"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column :label="$t('footmark.col2')">
        <template slot-scope="scope">
          <div class="row-product-name">
            <div class="discount" v-if="scope.row.IsCouponProduct">
              {{ $t("B2C.discount") }}
            </div>
            <div class="brand" v-if="scope.row.IsBrandProduct">
              {{ $t("B2C.brand") }}
            </div>
            <div class="attestation" v-if="scope.row.IsAttestationProduct">
              {{ $t("B2C.attestation") }}
            </div>
            <span class="name">{{ scope.row.ProductName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('footmark.col3')">
        <template slot-scope="scope">
          <p class="row-product-price">
            ${{ scope.row.MinPrice | formatPrice }}
          </p>
        </template>
      </el-table-column>
      <el-table-column :label="$t('footmark.col4')">
        <template slot-scope="scope">
          <div class="row-product-date">
            {{ scope.row.ReadTime }}
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('footmark.col5')">
        <template slot-scope="scope">
          <el-button-group>
            <el-button
              type="primary"
              size="small"
              @click="toDetail(scope.row.ProductNumber, scope.row.ShopId)"
              >{{ $t("footmark.viewProduct") }}</el-button
            >
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pagination"
      :current-page="page"
      :page-sizes="[1, 5, 10, 15, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="count"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "footmark",
  data() {
    return {
      OrderCount: {},
      state: null,
      page: 1,
      pageSize: 20,
      count: 0,
      lastPage: 0,
      tableData: [],
    };
  },
  created() {
    this.request(this.state, this.page);
  },
  methods: {
    ...mapActions(["getCUser"]),
    request(state, page) {
      const param = {
        PageIndex: page,
        PageSize: this.pageSize,
      };
      if (state !== null) {
        param.ScreenValues = state;
      }
      this.$api.cFollow
        .footmarkByPage(param)
        .then((res) => {
          this.state = state;
          this.page = res.meta.page;
          this.count = res.meta.total;
          this.lastPage = res.meta.lastPage;
          this.tableData = res.data;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.request(this.state, this.page);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.request(this.state, this.page);
    },
    stateChangeAction(state) {
      if (this.state === state) return;
      this.request(state, 1);
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value.split("|")[0]);
    },
    toDetail(productNumber, shopId) {
      this.$router.push({
        path: "/details",
        query: { ProductNumber: productNumber, ShopId: shopId },
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.footmark {
  padding: 50px;
  .image {
    width: 66px;
    height: 66px;
    flex-shrink: 0;
  }
  .row-product-name {
    color: #333;
    font-size: 14px;
    line-height: normal;
    .discount {
      vertical-align: middle;
      display: inline-block;
      background: red;
      color: white;
      padding: 0px 2px;
      border-radius: 2px;
      font-size: 12px;
      margin-right: 5px;
    }
    .brand {
      vertical-align: middle;
      display: inline-block;
      background: #e6a23c;
      color: white;
      padding: 0px 2px;
      border-radius: 2px;
      font-size: 12px;
      margin-right: 5px;
    }
    .attestation {
      vertical-align: middle;
      display: inline-block;
      background: #22b196;
      color: white;
      padding: 0px 2px;
      border-radius: 2px;
      font-size: 12px;
      margin-right: 5px;
    }
    .name {
      display: inline-block;
      vertical-align: middle;
    }
  }
  .row-product-price {
    margin: 0;
    font-size: 12px;
    color: #ff5852;
  }
  .row-product-date {
    margin: 0;
    font-size: 12px;
    color: #999;
  }
  .el-pagination {
    margin-top: 2%;
    margin-bottom: 2%;
    text-align: right;
  }
}
</style>
